import type {ButtonDocument} from 'prismicio-types'
import {DOWNLOAD_TEMPLATE_INTENT} from './constants'

const toComparableUrl = (url: string): string | null => {
  try {
    const {origin, pathname} = new URL(url)
    return `${origin}${pathname}`
  } catch {
    return null
  }
}

export const getDownloadTemplateUrls = (buttonsData: ButtonDocument[] = []): Set<string> => {
  const urls = buttonsData
    .filter((button) => button.data.intent === DOWNLOAD_TEMPLATE_INTENT)
    .map(({data: {link}}) => (link.link_type === 'Media' && 'url' in link ? toComparableUrl(link.url) : null))
    .filter((url): url is string => url !== null)

  return new Set(urls)
}

export const isDownloadTemplateHref = (href: string, downloadTemplateUrls: Set<string>): boolean => {
  const comparableHref = toComparableUrl(href)
  return comparableHref !== null && downloadTemplateUrls.has(comparableHref)
}
